
$(function () {
    $("[data-action=flush_logs]").each(function (idx, element) {

        var _renderError = function (e) {
            $(element).before("<div class='alert alert-danger alert-dismissable' role='alert'>"
                + "<button type='button' class='close' data-dismiss='alert' aria-label='Close'>"
                + "<span aria-hidden='true'>&times;</span></button>"
                + e
                + "</div>");
        };

        /**
         * Disables the anchor
         */
        var _disableBtn = function () {
            $(element).addClass("btn-loading")
                .children("span")
                .removeClass(function (idx, className) {
                    return (className.match(/(^|\s)fa\S+/g) || []).join(' ');
                })
                .first()
                .addClass("fas fa-spinner");

            $(element).addClass("disabled");
        };

        /**
         * Enables the anchor
         */
        var _enableBtn = function () {
            $(element)
                .removeClass("btn-loading")
                .removeClass("disabled")
                .children("span")
                .first()
                .removeClass("fa-spinner")
                .addClass("fa-tint");
        };

        /**
         * Flushes the buffer
         */
        var _flush = function () {
            _disableBtn();

            $.ajax({
                url: "/admin/errors/flush",
                method: "POST",
                dataType: "json",
                success: function (d) {
                    if (d.Success) {
                        $(".widget-grid").rebind();
                    } else {
                        _renderError(d.Error || "An unknown error occurred");
                    }
                },
                error: function (x, s, e) {
                    _renderError(e);
                },
                complete: function () {
                    _enableBtn();
                }
            })
        };

        $(element).click(function () {
            _flush();
        });

    });
})